module.exports = __webpack_public_path__ + "media/images/icons/compass-a6d0c2a4fd3ad1428330d650a0264115.svg";